<template>
<div class="flex flex-col items-center gap-4">
    <div class="flex items-center w-full gap-4">
        <slot name="title"> </slot>
        <button @click="toggleAccordion" >
            <font-awesome-icon icon="chevron-down" />
        </button>
    </div>
    <div id="content-1" class="w-full transition-all duration-300 ease-in-out"
        v-if="isAccordionOpen">
        <slot name="content"></slot>
    </div>
</div>
</template>
 
<script>
export default {
    data() {
        return {
            isAccordionOpen: true,
        };
    },
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    mounted() {
    },
    methods: {
        toggleAccordion() {
            this.isAccordionOpen = !this.isAccordionOpen;
        },
    },
};
</script>
